import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "f-w-700" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "f-w-700" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "f-w-700" }
const _hoisted_10 = { class: "col-sm-12 mt-3" }
const _hoisted_11 = { class: "f-w-700" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "f-w-700" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "f-w-700" }
const _hoisted_18 = { class: "f-w-700 my-3 col-12" }
const _hoisted_19 = {
  class: "custom-scrollbar list-container px-3 nav-link",
  style: {"height":"290px"}
}
const _hoisted_20 = ["onClick"]

import { computed, reactive, watch, onMounted } from 'vue'
import { usePromotionStore } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';

import { useI18n } from 'vue-i18n'
import { promotionTimeControlLanguage } from '@/core/locales/promotions-language';


export default /*@__PURE__*/_defineComponent({
  __name: 'promotionTimeControl',
  setup(__props) {

const { t } = useI18n({
  messages: promotionTimeControlLanguage
})

const promotionStore = usePromotionStore()
const DaysMock = [
    { id: '1', name: 'Sunday' },
    { id: '2', name: 'Monday' },
    { id: '3', name: 'Tuesday' },
    { id: '4', name: 'Wednesday' },
    { id: '5', name: 'Thursday' },
    { id: '6', name: 'Friday' },
    { id: '7', name: 'Saturday' },
]
const compState = reactive({
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    daysOfWeek: [] as string[]
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

const findIsSelectedDay = (id: string) => {
    return compState.daysOfWeek.includes(id)
}

const onDayClick = (id: string) => {
    if (compState.daysOfWeek.includes(id)) {
        compState.daysOfWeek = compState.daysOfWeek.filter(day => day !== id)
    } else {
        compState.daysOfWeek.push(id)
    }
}

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.startDate = tempActivePromotion.value.timeControl.startDate
        compState.endDate = tempActivePromotion.value.timeControl.endDate
        compState.startTime = tempActivePromotion.value.timeControl.startTime
        compState.endTime = tempActivePromotion.value.timeControl.endTime
        compState.daysOfWeek = tempActivePromotion.value.timeControl.daysOfWeek
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.startDate = promotion.timeControl.startDate
        compState.endDate = promotion.timeControl.endDate
        compState.startTime = promotion.timeControl.startTime
        compState.endTime = promotion.timeControl.endTime
        compState.daysOfWeek = promotion.timeControl.daysOfWeek
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        timeControl: {
            startDate: newVal.startDate,
            endDate: newVal.endDate,
            startTime: newVal.startTime,
            endTime: newVal.endTime,
            daysOfWeek: newVal.daysOfWeek
        }
    } as Promotion)
}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_3, _toDisplayString(_unref(t)('PromotionPeriodDateRange')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_6, _toDisplayString(_unref(t)('StartDate')), 1)
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control digits",
          type: "date",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.startDate) = $event))
        }, null, 512), [
          [_vModelText, compState.startDate]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_9, _toDisplayString(_unref(t)('EndDate')), 1)
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control digits",
          type: "date",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.endDate) = $event))
        }, null, 512), [
          [_vModelText, compState.endDate]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_11, _toDisplayString(_unref(t)('PromotionPeriodTimeOfDay')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_14, _toDisplayString(_unref(t)('StartTime')), 1)
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control digits",
          type: "time",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.startTime) = $event))
        }, null, 512), [
          [_vModelText, compState.startTime]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_17, _toDisplayString(_unref(t)('EndTime')), 1)
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control digits",
          type: "time",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.endTime) = $event))
        }, null, 512), [
          [_vModelText, compState.endTime]
        ])
      ])
    ]),
    _createElementVNode("h6", _hoisted_18, _toDisplayString(_unref(t)('DaysOfWeek')), 1),
    _createElementVNode("div", _hoisted_19, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(DaysMock, (item) => {
        return _createElementVNode("div", {
          class: "text-center text-dark rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center gap-2",
          onClick: ($event: any) => (onDayClick(item.id)),
          style: _normalizeStyle([{ boxShadow: findIsSelectedDay(item.id) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }, {"grid-column":"span 1 / span 1","height":"112px","user-select":"none"}])
        }, [
          _createElementVNode("h5", null, _toDisplayString(_unref(t)(item.name)), 1)
        ], 12, _hoisted_20)
      }), 64))
    ])
  ]))
}
}

})